import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-6" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "mt-6" }
const _hoisted_4 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_input = _resolveComponent("the-input")!
  const _component_file_reader = _resolveComponent("file-reader")!
  const _component_modal = _resolveComponent("modal")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_templates_list_filters = _resolveComponent("templates-list-filters")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_button_dropdown = _resolveComponent("button-dropdown")!
  const _component_the_table = _resolveComponent("the-table")!
  const _component_table_scroll_wrapper = _resolveComponent("table-scroll-wrapper")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.state.is_add)
      ? (_openBlock(), _createBlock(_component_modal, {
          key: 0,
          class: "large",
          title: _ctx.modalTitle,
          loading: _ctx.state.is_template_loading,
          onCancel: _ctx.resetTemplate,
          onConfirm: _ctx.manageTemplate
        }, {
          default: _withCtx(() => [
            _createVNode(_component_the_input, {
              placeholder: "Наименование шаблона",
              value: _ctx.state.template_name,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.template_name) = $event)),
              "is-invalid": _ctx.state_form$.template_name.$error,
              "validation-errors": _ctx.state_form$.template_name.$errors
            }, null, 8, ["value", "is-invalid", "validation-errors"]),
            _createVNode(_component_file_reader, {
              accept: "all",
              class: "mt-2",
              placeholder: "Файл",
              value: _ctx.state.template_file,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.template_file) = $event)),
              "is-invalid": _ctx.state_form$.template_file.$error,
              "validation-errors": _ctx.state_form$.template_file.$errors
            }, null, 8, ["value", "is-invalid", "validation-errors"])
          ]),
          _: 1
        }, 8, ["title", "loading", "onCancel", "onConfirm"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_page_title, { title: "Список шаблонов" }),
        _createVNode(_component_the_button, {
          class: "primary small",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.is_add = true))
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Добавить шаблон ")
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_templates_list_filters, {
        class: "mt-6",
        loading: _ctx.data_state.is_loading,
        onSearch: _ctx.applyFilters,
        onResetted: _ctx.resetFilters
      }, null, 8, ["loading", "onSearch", "onResetted"]),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.data_state.is_failed && !_ctx.data_state.failure.error_state.is_cancel)
          ? (_openBlock(), _createBlock(_component_failed_fetch, {
              key: 0,
              loading: _ctx.data_state.is_loading,
              text: "При получении списка произошла ошибка",
              "error-message": _ctx.data_state.failure.error_state.message,
              "error-url": _ctx.data_state.failure.error_state.url,
              "error-status": _ctx.data_state.failure.error_state.status,
              onRefresh: _cache[3] || (_cache[3] = ($event: any) => (_ctx.loadTemplates(_ctx.data_state.pagination.current_page)))
            }, null, 8, ["loading", "error-message", "error-url", "error-status"]))
          : (_openBlock(), _createBlock(_component_table_scroll_wrapper, {
              key: 1,
              loading: _ctx.data_state.is_loading
            }, {
              default: _withCtx(() => [
                _createVNode(_component_the_table, {
                  loading: _ctx.data_state.is_loading,
                  columns: _ctx.TemplatesColumns,
                  rows: _ctx.data_state.list,
                  "with-limit": "",
                  "pagination-limit": _ctx.filters_state.limit,
                  "pagination-total-items": _ctx.data_state.pagination.total_items,
                  "pagination-current-page": _ctx.data_state.pagination.current_page,
                  "pagination-total-pages": _ctx.data_state.pagination.total_pages,
                  onChangePage: _ctx.loadTemplates,
                  onChangeLimit: _ctx.onLimitChange
                }, {
                  td: _withCtx(({ row, column }) => [
                    (column.key === 'createdAt')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(_ctx.formatDateWithTimeFromBackend(row.createdAt)), 1)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(row[column.key]), 1)
                        ], 64))
                  ]),
                  actions: _withCtx(({ row }) => [
                    _createVNode(_component_button_dropdown, {
                      icon: "fas fa-ellipsis-h",
                      class: "max-w-min"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_the_button, {
                          class: "primary small text",
                          onClick: ($event: any) => (_ctx.onEditTemplate(row))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Редактировать ")
                          ]),
                          _: 2
                        }, 1032, ["onClick"]),
                        (row.url)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              href: row.url,
                              target: "_blank"
                            }, [
                              _createVNode(_component_the_button, { class: "primary small text" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Скачать ")
                                ]),
                                _: 1
                              })
                            ], 8, _hoisted_4))
                          : _createCommentVNode("", true),
                        _createVNode(_component_the_button, {
                          class: "red small text",
                          onClick: ($event: any) => (_ctx.deleteTemplate(row))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Удалить ")
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                }, 8, ["loading", "columns", "rows", "pagination-limit", "pagination-total-items", "pagination-current-page", "pagination-total-pages", "onChangePage", "onChangeLimit"])
              ]),
              _: 1
            }, 8, ["loading"]))
      ])
    ])
  ], 64))
}